export const getInitialState = (): any => ({
  dataProcessingStatusData: {}
});
